var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.loading)?_c('button',{staticClass:"form-submit-button",style:(_vm.$styles.submitButton()),on:{"click":_vm.handleSubmit}},[_vm._v(" "+_vm._s(_vm.text)+" ")]):_vm._e(),(_vm.loading)?_c('Spinner'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }